import { graphql, useMutation } from "react-relay"
import { useConfirmPatientRecordExportMutation as UseConfirmPatientRecordExportMutation } from "@/modules/patients/detail/record-extract/services/__generated__/useConfirmPatientRecordExportMutation.graphql"

const mutation = graphql`
  mutation useConfirmPatientRecordExportMutation($input: Ch_confirmPatientRecordExportInput!) {
    ch_confirmPatientRecordExport(input: $input) {
      confirmPatientRecordExportOutput {
        requestId
        status
      }
    }
  }
`

const useConfirmPatientRecordExportMutation = () => useMutation<UseConfirmPatientRecordExportMutation>(mutation)

export { useConfirmPatientRecordExportMutation }
